import React, { FC } from 'react';
import { Tabs } from 'snacks-design-system';
export enum PIETabSize {
  WIDE = 'wide',
  NARROW = 'narrow',
}
export enum PIETabBgColor {
  REGULAR = 'regular',
  SUBTLE = 'subtle',
  STRONG = 'strong',
}

interface componentProps {
  children: React.ReactNode;
  size?: PIETabSize;
  bgColor?: PIETabBgColor;
  modBorder?: boolean;
  modFluid?: boolean;
  modScrollable?: boolean;
  aria?: { label: string };
  dataSctrack?: string;
  qaSelector?: string;
}

const PIETab: FC<componentProps> = (props: componentProps) => {
  return <Tabs {...props}>{props.children}</Tabs>;
};

export default PIETab;
